import { createSlice } from "@reduxjs/toolkit";
import { ORG_TYPES } from "../components/Common/Constants";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isLoggedIn: localStorage.getItem("userToken") !== null,
    dealerLayout:
      localStorage.getItem("userDetails")?.currentOrganisation?.type ===
      ORG_TYPES.DEALER,
    dealerSlideShow: false,
    roles: [],
    navStop: false,
    phoneNumber: null,
  },
  reducers: {
    setLoggedIn: (state) => {
      return {
        ...state,
        isLoggedIn: true,
      };
    },
    setLoggedOut: (state) => {
      return {
        ...state,
        isLoggedIn: false,
      };
    },
    setRoles: (state, action) => {
      return {
        ...state,
        roles: action.payload,
      };
    },
    setDealerSlideShow: (state, action) => {
      return {
        ...state,
        dealerSlideShow: action.payload,
      };
    },
    setNavStop: (state, action) => {
      return {
        ...state,
        navStop: action.payload,
      };
    },
    setPhoneNumber: (state, action) => {
      state.phoneNumber = action.payload;
    },
  },
});

export const {
  setLoggedIn,
  setLoggedOut,
  setRoles,
  setDealerSlideShow,
  setNavStop,
  setPhoneNumber,
} = authSlice.actions;
export default authSlice.reducer;
